import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { LinkProps } from 'react-router-dom';

import useIsMobile from '../../../../hooks/useIsMobile';

import MetaContainerPopup from '../../../MetaContainerPopup';

export type Props = PropsWithChildren & {
  idHeading: string;
  inputCustom?: ReactNode;
  isActive: boolean;
  linkToggleProps: LinkProps;
  textHeading: string;
  value: string;
};

/**
 * Compose section component used for the compose
 *
 * @param props                 Props passed to the component
 * @param props.children        Contents of the compose section
 * @param props.idHeading       id attribute for the component heading
 * @param props.inputCustom     Component to use for overview in mobile view
 * @param props.isActive        Whether the component should be visible
 * @param props.linkToggleProps Props for the toggle link
 * @param props.textHeading     The text to show for heading
 * @param props.value           Textual representation of the field's value
 * @returns                     The component itself
 */
const ComposeSection: FC<Props> = ({
  children,
  idHeading,
  inputCustom,
  isActive,
  linkToggleProps,
  textHeading,
  value,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    /**
     * This props are necessary for MetaContainerPopup to work properly but
     * not used in compose section
     */
    const commonProps = {
      isSaveDisabled: true,
      labelConfirm: '',
      placeholder: '',
    };

    return (
      <MetaContainerPopup
        {...commonProps}
        idHeading={idHeading}
        inputCustom={inputCustom}
        linkProps={linkToggleProps}
        shouldHideSave={true}
        shouldShowPopup={isActive}
        textHeading={textHeading}
        value={value}
      >
        {children}
      </MetaContainerPopup>
    );
  }

  return children;
};

export default ComposeSection;
